import React from "react";
import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useEffect, useState } from "react";
import { upperPart } from "../dashboard/api";
import { message } from "antd";
import { DatePicker } from "antd";
import './index.scss'

interface Goals {
  deepChatCount?: number;
  deepChatFinishPercent?: string;
  deepChatNextGoalCount?: number;
  ppvCount?: number;
  ppvFinishPercent?: string;
  ppvNextGoalCount?: number;
}

// 加载插件
dayjs.extend(utc);
dayjs.extend(timezone);
const DatePickerCustom = ({ callback }: any) => {
  const [open, setOpen] = useState(false); //控制日期选择
  const [curData, setCurData] = useState(dayjs().tz("America/Los_Angeles"));
  const today = dayjs().tz("America/Los_Angeles");
  const startOfWeek = today.day(1);
  const startOfLastWeek = startOfWeek.subtract(1, "week");

  useEffect(() => {
    localStorage.removeItem("lastTime");
    getUpperPart({ queryDate: dayjs(curData).format("YYYYMMDD") });
    callback(curData);
  }, [curData]);

  const { run: getUpperPart } = upperPart({
    onSuccess: (res: any, params: any) => {
      const goals: Goals = res?.chatterThisWeekGoalVO || {};
      localStorage.setItem("rating", res?.chatterRatingVO.ratingLevel || "");
      localStorage.setItem("goals", JSON.stringify(goals));
      localStorage.setItem("lastTime", res.lastUpdateTime);
    },
    onError: (err: any) => {
      message.warning(err || "please try again");
    },
  });

  // 禁用日期函数
  const disabledDate = (current: any) => {
    return (
      current.isBefore(startOfLastWeek, "day") || current.isAfter(today, "day")
    );
  };

  const onOpenChange = (status: any) => {
    setOpen(status);
  };

  return (
    <div className="basic-d">
      <div style={{ position: "absolute", zIndex: 1, margin: "4px 10px" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="11"
          viewBox="0 0 10 11"
          fill="none"
        >
          <path
            d="M10 9.23828C10 10.2128 9.21 11 8.23548 11H1.76467C0.790152 11 0.000142431 10.2111 0.000129092 9.23658C0.000102933 7.32558 5.52943e-05 4.43565 2.57776e-05 2.68293C1.1665e-05 1.84492 0.679352 1.16875 1.51737 1.16875V1.58125C1.51737 2.2 2.00012 2.75 2.68976 2.75C3.31044 2.75 3.86216 2.26875 3.86216 1.58125V1.16875H6.13799V1.58125C6.13799 2.2 6.62074 2.75 7.31038 2.75C8.00003 2.75 8.48278 2.26875 8.48278 1.58125V1.16875C9.32072 1.16875 10 1.84498 10 2.68292C10 4.44198 10 7.34436 10 9.23828ZM9.10346 5.0474C9.10346 4.34812 8.53659 3.78125 7.83732 3.78125H2.0249C1.32563 3.78125 0.758757 4.34812 0.758757 5.0474V8.9776C0.758757 9.67688 1.32563 10.2437 2.0249 10.2437H7.83732C8.53659 10.2437 9.10346 9.67688 9.10346 8.9776V5.0474ZM2.68976 5.20787C2.68976 5.48312 2.46663 5.70625 2.19139 5.70625H2.01574C1.7405 5.70625 1.51737 5.48312 1.51737 5.20787V5.03588C1.51737 4.76063 1.7405 4.5375 2.01574 4.5375H2.19139C2.46663 4.5375 2.68976 4.76063 2.68976 5.03588V5.20787ZM2.68976 7.06412C2.68976 7.33937 2.46663 7.5625 2.19139 7.5625H2.01574C1.7405 7.5625 1.51737 7.33937 1.51737 7.06412V6.96088C1.51737 6.68563 1.7405 6.4625 2.01574 6.4625H2.19139C2.46663 6.4625 2.68976 6.68563 2.68976 6.96088V7.06412ZM2.68976 8.98912C2.68976 9.26437 2.46663 9.4875 2.19139 9.4875H2.01574C1.7405 9.4875 1.51737 9.26437 1.51737 8.98912V8.81713C1.51737 8.54188 1.7405 8.31875 2.01574 8.31875H2.19139C2.46663 8.31875 2.68976 8.54188 2.68976 8.81713V8.98912ZM3.94675 5.70625C3.6715 5.70625 3.44837 5.48312 3.44837 5.20787V5.03588C3.44837 4.76063 3.6715 4.5375 3.94675 4.5375H4.12239C4.39764 4.5375 4.62077 4.76063 4.62077 5.03588V5.20787C4.62077 5.48312 4.39764 5.70625 4.12239 5.70625H3.94675ZM3.94675 7.5625C3.6715 7.5625 3.44837 7.33937 3.44837 7.06412V6.96088C3.44837 6.68563 3.6715 6.4625 3.94675 6.4625H4.12239C4.39764 6.4625 4.62077 6.68563 4.62077 6.96088V7.06412C4.62077 7.33937 4.39764 7.5625 4.12239 7.5625H3.94675ZM3.94675 9.4875C3.6715 9.4875 3.44837 9.26437 3.44837 8.98912V8.81713C3.44837 8.54188 3.6715 8.31875 3.94675 8.31875H4.12239C4.39764 8.31875 4.62077 8.54188 4.62077 8.81713V8.98912C4.62077 9.26437 4.39764 9.4875 4.12239 9.4875H3.94675ZM6.48281 5.20787C6.48281 5.48312 6.25968 5.70625 5.98443 5.70625H5.80879C5.53354 5.70625 5.31041 5.48312 5.31041 5.20787V5.03588C5.31041 4.76063 5.53354 4.5375 5.80879 4.5375H5.98443C6.25968 4.5375 6.48281 4.76063 6.48281 5.03588V5.20787ZM6.48281 7.06412C6.48281 7.33937 6.25968 7.5625 5.98443 7.5625H5.80879C5.53354 7.5625 5.31041 7.33937 5.31041 7.06412V6.96088C5.31041 6.68563 5.53354 6.4625 5.80879 6.4625H5.98443C6.25968 6.4625 6.48281 6.68563 6.48281 6.96088V7.06412ZM6.48281 8.98912C6.48281 9.26437 6.25968 9.4875 5.98443 9.4875H5.80879C5.53354 9.4875 5.31041 9.26437 5.31041 8.98912V8.81713C5.31041 8.54188 5.53354 8.31875 5.80879 8.31875H5.98443C6.25968 8.31875 6.48281 8.54188 6.48281 8.81713V8.98912ZM8.34485 5.20787C8.34485 5.48312 8.12172 5.70625 7.84648 5.70625H7.67083C7.39559 5.70625 7.17245 5.48312 7.17245 5.20787V5.03588C7.17245 4.76063 7.39559 4.5375 7.67083 4.5375H7.84648C8.12172 4.5375 8.34485 4.76063 8.34485 5.03588V5.20787ZM8.34485 7.06412C8.34485 7.33937 8.12172 7.5625 7.84648 7.5625H7.67083C7.39559 7.5625 7.17245 7.33937 7.17245 7.06412V6.96088C7.17245 6.68563 7.39559 6.4625 7.67083 6.4625H7.84648C8.12172 6.4625 8.34485 6.68563 8.34485 6.96088V7.06412ZM8.34485 8.98912C8.34485 9.26437 8.12172 9.4875 7.84648 9.4875H7.67083C7.39559 9.4875 7.17245 9.26437 7.17245 8.98912V8.81713C7.17245 8.54188 7.39559 8.31875 7.67083 8.31875H7.84648C8.12172 8.31875 8.34485 8.54188 8.34485 8.81713V8.98912ZM7.30877 2.26875C6.89498 2.26875 6.55016 1.925 6.55016 1.5125V0.75625C6.55016 0.34375 6.89498 0 7.30877 0C7.72255 0 8.06738 0.34375 8.06738 0.75625V1.5125C8.06738 1.925 7.72255 2.26875 7.30877 2.26875ZM2.68815 2.26875C2.27436 2.26875 1.92954 1.925 1.92954 1.5125V0.75625C1.9985 0.34375 2.27436 0 2.68815 0C3.10193 0 3.44676 0.34375 3.44676 0.75625V1.5125C3.44676 1.925 3.10193 2.26875 2.68815 2.26875Z"
            fill="#111111"
          />
        </svg>
      </div>
      <DatePicker
        inputReadOnly={true}
        defaultValue={dayjs(today, "YYYY-MM-DD")}
        onChange={(date, dateString: any) => {
          setCurData(dateString);
        }}
        open={open}
        onOpenChange={onOpenChange}
        allowClear={false}
        disabledDate={disabledDate}
        suffixIcon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="5"
            viewBox="0 0 8 5"
            fill="none"
          >
            <path d="M1 1L4 3.5L7 1" stroke="#111111" strokeLinecap="round" />
          </svg>
        }
      />
    </div>
  );
};

export default DatePickerCustom;
